import React from "react";
import { ReactComponent as HeaderLogo } from "./assets/headerLogo.svg";
import phoneMockup from "./assets/mobile.png";
import "./App.scss";
import { Link } from "react-router-dom";
import SupportLauncher from "./support-launcher";

const App = () => {
  return (
    <div className="container">
      <main className="main-frame">
        <header className="header">
          <div className="header-left">
            <HeaderLogo />
            <div className="logo">Macryx</div>
          </div>

          <div className="header-right">
            <div className="contactBubble">
              Feel free to contact us if you are looking for some help or
              partnership
            </div>
            <button className="contactButton">support@macryx.app</button>
          </div>
        </header>

        <main className="mainContent">
          {/* Left column: text + buttons grouped together */}
          <div className="textColumn">
            <div className="textContent">
              Your Personal AI Assistant for Weight Loss and Balanced Nutrition
            </div>

            <div className="actionButtons">
              <a
                href="https://quiz.macryx.app"
                target="_blank"
                rel="noreferrer"
                className="quizButton"
              >
                Start Quiz
              </a>
              <a
                href="https://app.macryx.app"
                target="_blank"
                rel="noreferrer"
                className="loginButton"
              >
                Open App
              </a>
            </div>
          </div>

          <img src={phoneMockup} alt="Phone Mockup" className="phoneMockup" />
        </main>

        <footer className="footer">
          <div className="footer-left">
            <span className="footer-left-first">EL Care LLC</span>
            <span className="footer-left-second">
            7910 4th Street North, 300, St. Petersburg, FL, United States
            </span>
          </div>

          <div className="footer-right">
            <span className="footer-right-first">support@macryx.app</span>
            <span className="footer-right-second">+1 (239) 309-7286</span>
          </div>

          <div className="footer-links">
            <Link to="/privacy" className="footer-link">Privacy Policy</Link>
            <Link to="/terms-of-use" className="footer-link">Terms of Use</Link>
            <Link to="/refund-terms" className="footer-link">Refund & Cancellation Policy</Link>
          </div>
        </footer>
      </main>

      <SupportLauncher />
    </div>
  );
};

export default App;